export function toUiMessage(m) {
    return {
        id: String(m.id),
        clientMsgId: m.clientMsgId ?? null,
        senderType: m.senderType,
        senderId: m.senderId ?? null,
        msgType: m.msgType,
        content: m.content ?? null,
        assetUrl: m.assetUrl ?? null,
        meta: m.meta ?? null,
        createdAt: m.createdAt ?? null,
    };
}
function sortKey(m) {
    const t = m.createdAt ? Date.parse(m.createdAt) : Date.now();
    const n = Number(m.id);
    return [Number.isFinite(t) ? t : 0, Number.isFinite(n) ? n : Number.MAX_SAFE_INTEGER];
}
// 合并消息：临时消息（tmp-*）与其服务端回包按 clientMsgId 合并；按时间排序
export function mergeMessages(current, incoming) {
    const map = new Map();
    const keyOf = (m) => (m.clientMsgId ? `c:${m.clientMsgId}` : `i:${m.id}`);
    for (const m of current)
        map.set(keyOf(m), m);
    for (const m of incoming) {
        const key = keyOf(m);
        const prev = map.get(key);
        if (!prev && m.clientMsgId) {
            // 兼容旧临时键（tmp-* 无 clientMsgId 的异常路径）
            map.delete(`i:tmp-${m.clientMsgId}`);
        }
        map.set(key, { ...prev, ...m, pending: false, failed: false });
    }
    return [...map.values()].sort((a, b) => {
        const [ta, ia] = sortKey(a);
        const [tb, ib] = sortKey(b);
        return ta === tb ? ia - ib : ta - tb;
    });
}
export function queueText(queue, human) {
    if (human)
        return '客服已接入';
    if (!queue || queue.position == null)
        return 'AI 服务中';
    if (queue.position <= 1)
        return `正在为您接入人工客服，前面还有 ${Math.max(queue.size - 1, 0)} 位`;
    return `排队中：前面还有 ${queue.position - 1} 位`;
}
export function formatTime(iso) {
    if (!iso)
        return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return '';
    const pad = (n) => String(n).padStart(2, '0');
    // 当天只显示时分；跨天补日期，避免"01:19"与"08:05"看起来先后颠倒
    const now = new Date();
    const sameDay = d.getFullYear() === now.getFullYear() &&
        d.getMonth() === now.getMonth() &&
        d.getDate() === now.getDate();
    return sameDay
        ? `${pad(d.getHours())}:${pad(d.getMinutes())}`
        : `${d.getMonth() + 1}/${d.getDate()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
export function formatFullTime(iso) {
    if (!iso)
        return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return '';
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}
export function maxServerId(list) {
    return list.reduce((mx, m) => {
        const n = Number(m.id);
        return Number.isFinite(n) && n > mx ? n : mx;
    }, 0);
}
export function inferMsgType(file) {
    const type = file.type || '';
    if (type.startsWith('image/'))
        return 'image';
    if (type.startsWith('video/'))
        return 'video';
    const ext = (file.name.split('.').pop() ?? '').toLowerCase();
    if (['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(ext))
        return 'image';
    if (['mp4', 'webm', 'mov'].includes(ext))
        return 'video';
    return 'file';
}
//# sourceMappingURL=messages.js.map